import { useContext, useEffect, useState } from "react";
import {
  Box, Button, MenuItem, FormControl, IconButton, InputLabel,
  Paper, Select, Stack, Table, TableBody, TableCell, Container,
  TableContainer, TableHead, TableRow, styled, tableCellClasses,
  Pagination, Divider, TextField, InputAdornment,
  Typography, Backdrop, CircularProgress, Tooltip
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import UpdateIcon from '@mui/icons-material/Update';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ClearIcon from "@mui/icons-material/Clear";
import Cookies from "universal-cookie";
import axios, { AxiosInstance } from "axios";
import { AlertType } from "../../../../types/AlertType";
import { DataRef } from "../../../../types/DataRef";
import { SnackBarAlert } from "../../../element/SnackBarAlert";
import { tableStyle } from "../Pays/Pays";
import { ICodeArticle } from "../../../forms/OperationAjoutForm";
import OperationForm from "../../../forms/operation/OperationForm";
import OperationRow from "./OperationRow";
import RefreshIcon from "@mui/icons-material/Refresh";
import { IClient } from "../Client/InterfaceClient";
import { useLocation } from "react-router";
import CheckAttr from "../../../../utils/CheckAttr";
import OptionalWidthModal from "../../../../commons/optional-width-modal/OptionalWidthModal";
import { useNavigate } from "react-router-dom";
import UpdateCodeGescoForm from "../../../forms/operation/UpdateCodeGescoForm";
import { LoadingButton } from "@mui/lab";
import dayjs from "dayjs";
import { loggoutUser } from "../../../../redux/actions/logginUser";
import { useDispatch } from 'react-redux';
import { MediaQueryContext } from "../../../../utils/contextes/MediaQueryContext";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    textAlign: "center",
    fontSize: 11,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
    textAlign: "center",
    color: "#fff",
  },
}));

interface User {
  id: number;
  name: string;
  email: string;
  email_verified_at: any;
  updated_password: number;
  prenom: string;
  Departement: string;
  pays: string;
  actif: string;
  profil_user_id: number;
  created_at: string;
  updated_at: string;
  date_suppression: any;
}
export interface IOperation {
  id: number;
  libelle: string;
  actif: boolean;
  association_parametrage_id: number;
  code_article_id: number;
  idSocieteFacturation: any;
  idOperationIrm: number;
  EstHno: number;
  EstFormation: number;
  societe_facturations_id: number;
  created_at: string;
  updated_at: string;
  date_suppression: any;
  code_article: ICodeArticle;
  association_parametrage: IAssociationParametrage;
  societe_facturation: ISocieteFacturation;
  tarification_count: number;
  saisie_manager_count: number;
  cout_count: number;
  manager_operation_count: number;
  operation_sage_id?: number;
  users: User[];
}

export interface IAssociationParametrage {
  id: number;
  created_at?: string;
  updated_at?: string;
  pays_id?: number;
  bu_id?: number;
  clients_id?: number;
  date_suppression?: any;
  pays: DataRef;
  bu: DataRef;
  client: IClient;
  operations?: IOperation[];
}

export interface ISocieteFacturation {
  id: number;
  libelle: string;
  activite: string;
  forme_juridique: string;
  capital: string;
  adresse: string;
  code_postal: string;
  ville: string;
  registre_commerce: any;
  identifiant_fiscal: any;
  pays_facturation_id: number;
  created_at: any;
  updated_at: any;
  date_suppression: any;
  code?: string;
}

export interface SociFact {
  id: number;
  libelle: number;
  pivot: {
    operation_id: number;
    societe_facturation_id: number;
  };
}
export interface CodeGesco {
  id: number;
  libelle: string;
  libelleCodeGesco: string;
  intituleTiers: string;
}

export interface Article {
  id: number;
  code_gesco_id: 3;
  societe_facturation_id: 4;
  articles: DataRef[];
}
export interface FirstPivot {
  id: number;
  articles: DataRef[];
  periode_facturations_id?: number;
  periode_facturation: DataRef;
  piv_socifact_code_gescos: {
    id: number;
    societe_facturation: DataRef;
    code_gesco: CodeGesco;
  };
}

export interface DataOperation {
  id: number;
  libelle: string;
  client: DataRef;
  secteur_activites: DataRef[];
  actif: boolean;
  pivot_oper_socifact_code_gesco: FirstPivot[];
}

const urlBaseApi = process.env.REACT_APP_BASE_API_URL as string;

const Operation = () => {
  const { isDesktopOrLaptop } = useContext(MediaQueryContext);
  
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [openCodeGescoModal, setOpenCodeGescoModal] = useState<boolean>(false);
  const [isExporting, setIsExporting] = useState<boolean>(false);
  const [openSnack, setOpenSnack] = useState<boolean>(false);
  const [refresh, setRefresh] = useState<boolean>(false);

  const [page, setPage] = useState<number>(1);
  const [rowsPerPage, setRowsPerPage] = useState<number>(5);
  const [totalData, setTotalData] = useState<number>(0);
  const [clientFilter, setClientFilter] = useState<number | string>("");
  // "" = tous, "1" = Activer, "0" = Désactiver
  const [statutFilter, setStatutFilter] = useState<string>("");
  const [operationSearch, setOperationSearch] = useState<string>("");
  const [expanded, setExpanded] = useState<number | false>(false);

  const [alertMessage, setAlerteMessage] = useState<string>("");
  const [alertType, setAlertType] = useState<AlertType>("success");

  const [dataClientsFilter, setDataClientsFilter] = useState<DataRef[]>([]);
  const [dataOperations, setDataOperations] = useState<DataOperation[]>([]);
  const [periodeRefAll, setPeriodeRefAll] = useState<DataRef[]>([]);

  const [dataClients, setDataClients] = useState<DataRef[]>([]);
  const [dataSecteurActivites, setDataSecteurActivites] = useState<DataRef[]>([]);
  const [dataSocieteFacturations, setDataSocieteFacturations] = useState<DataRef[]>([]);

  const cookies = new Cookies();
  const token: string = cookies.get("jwt");
  const http: AxiosInstance = axios.create({
    baseURL: urlBaseApi,
    // timeout: 1000,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  // Add global response interceptor
  http.interceptors.response.use(
    (response) => {
      // Modify response data here, if needed
      return response;
    },
    (error) => {
      console.log(error.message);
      if (error.message === "Request failed with status code 401") {
        // Remove the redux store
        dispatch(loggoutUser());

        // Remove token in navigator cookies
        cookies.remove('jwt', { path: '/' });

        navigate("/sign-in");
      }
      return Promise.reject(error);
    }
  );

  const retrieveData = () => {
    // Récupère les saisies managers
    setIsLoading(true);

    let customerFilter = clientFilter;
    if (!CheckAttr(clientFilter)) {
      if (CheckAttr(location?.state)) {
        customerFilter = location?.state?.client?.id;
      }
    } else {
      navigate(location.pathname, { replace: true });
    }

    http.post("operation/list", {
      clientFilter: customerFilter,
      statutFilter,
      operationSearch,
      rowsPerPage,
      page,
    }).then((res) => {
      const { total, data } = res.data;

      setTotalData(total);
      Array.isArray(data) && setDataOperations(data);
    }).catch((error) => {
      console.log(error);
    }).finally(() => {
      setIsLoading(false);
    });
  };

  const getDataPeriodeRef = () => {
    // Recupere Les Periode
    http
      .get("periode/get")
      .then((res) => {
        Array.isArray(res.data) && setPeriodeRefAll(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    // Recupère les clients pour le filtre
    http
      .post("client/search")
      .then((res) => {
        const { data } = res.data;
        Array.isArray(data) && setDataClientsFilter(data);
      })
      .catch((error) => {
        console.log(error);
      });

    // Recupère tous les societe de facturations
    http
      .get("societe-facturation/find/all")
      .then((res) => {
        Array.isArray(res.data) && setDataSocieteFacturations(res.data);
      })
      .catch((error) => {
        console.log(error);
      });

    // Recupère tous les societe de facturations
    http
      .get("secteur-activite/find/all")
      .then((res) => {
        Array.isArray(res.data) && setDataSecteurActivites(res.data);
      })
      .catch((error) => {
        console.log(error);
      });

    // Recupère les clients pour l'ajout dans le formulaire
    http
      .get("operation/get-clients/distinct")
      .then((res) => {
        Array.isArray(res.data) && setDataClients(res.data);
      })
      .catch((error) => {
        console.log(error);
      });

    // Recupere Les Periode
    getDataPeriodeRef();
  }, []);

  useEffect(() => {
    // Récupère les saisies managers
    retrieveData();
  }, [rowsPerPage, page, refresh, clientFilter, statutFilter]);

  const handleSearch = () => {
    if (CheckAttr(location?.state)) {
      navigate(location.pathname, { replace: true });
    }

    retrieveData();
  };

  const reloadList = () => {
    setRefresh(!refresh);
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  const handleClose2 = () => {
    setOpenCodeGescoModal(false);
  };

  /**
   * Exporte les opérations avec leur statut, selon les filtres client et statut de la liste
   * (ou le client reçu en navigation, comme pour la liste)
   */
  const handleExport = () => {
    const customerFilter = CheckAttr(clientFilter) ? clientFilter : (location?.state?.client?.id ?? "");
    const client = dataClientsFilter.find((elem) => String(elem?.id) === String(customerFilter))
      ?? (CheckAttr(customerFilter) ? location?.state?.client as DataRef : undefined);

    // Nom du fichier : Export_operation_<date> sans filtre, Export_operation_<nom client>_<date> avec filtre
    const date = dayjs().format("YYYY-MM-DD");
    const filename = CheckAttr(client?.libelle)
      // Retire les caractères interdits dans un nom de fichier
      ? `Export_operation_${String(client?.libelle).trim().replace(/[\\/:*?"<>|\s]+/g, "_")}_${date}.xlsx`
      : `Export_operation_${date}.xlsx`;

    setIsExporting(true);

    // Le fichier est renvoyé directement par l'API (pas de stockage côté serveur)
    http.post("operation/export", { clientFilter: customerFilter, statutFilter }, { responseType: "blob" })
      .then((res) => {
        const url = URL.createObjectURL(res.data as Blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        link.click();
        URL.revokeObjectURL(url);

        setAlerteMessage("Export effectué !");
        setAlertType("success");
        setOpenSnack(true);
      }).catch((error) => {
        console.log(error);
        setAlerteMessage("Une erreur est survenue lors de l'export des opérations !");
        setAlertType("error");
        setOpenSnack(true);
      }).finally(() => {
        setIsExporting(false);
      });
  };

  const handleCloseAlert = () => {
    setOpenSnack(false);
  };

  const resetFilter = () => {
    setPage(1);
    setRowsPerPage(5);
    setClientFilter("");
    setStatutFilter("");
    setOperationSearch("");

    if (CheckAttr(location?.state)) {
      navigate(location.pathname, { replace: true });
    }

    reloadList();
  };

  const handleChangeSearchValue = (e: any) => {
    const { value } = e.target;
    if (CheckAttr(value)) {
      setOperationSearch(value);
    } else {
      resetFilter();
    }
  }

  const pagination: JSX.Element | boolean = (
    <Stack spacing={2} direction="row">
      <InputLabel sx={{ color: "#fff" }}>Lignes par page :</InputLabel>
      <FormControl variant="standard" sx={{ minWidth: 50 }}>
        <Select
          labelId="demo-simple-select-standard-label"
          id="demo-simple-select-standard"
          color="warning"
          sx={{ background: "#fff", borderRadius: 1, paddingLeft: 1 }}
          value={rowsPerPage}
          onChange={(e) => setRowsPerPage(e.target.value as number)}
          defaultValue={5}
        >
          <MenuItem value={5}>5</MenuItem>
          <MenuItem value={10}>10</MenuItem>
          <MenuItem value={25}>25</MenuItem>
          <MenuItem value={50}>50</MenuItem>
        </Select>
      </FormControl>
      {!isLoading && totalData > rowsPerPage && (
        <Pagination
          count={Math.ceil(totalData / rowsPerPage)}
          color="standard"
          sx={{ button: { color: "white" } }}
          showFirstButton={true}
          showLastButton={true}
          siblingCount={0}
          boundaryCount={1}
          defaultPage={page}
          onChange={(event, value) => setPage(value)}
        />
      )}
    </Stack>
  );

  const stackAlert: JSX.Element = SnackBarAlert(
    openSnack,
    handleCloseAlert,
    alertType,
    alertMessage
  );

  const defaultClient: DataRef | undefined = location?.state && location?.state?.client as DataRef;

  // Styles communs de l'en-tête : même hauteur pour les boutons et les filtres
  const toolbarBtnSx = {
    height: 40, fontSize: 12, textTransform: "none", px: 1, minWidth: 0, whiteSpace: "nowrap"
  } as const;
  const whiteBtnSx = {
    backgroundColor: "#fff",
    color: "Gray",
    '&:hover': { backgroundColor: "#EBEAEA" },
  } as const;
  const filterFieldSx = { bgcolor: "#fff", borderRadius: 1, height: 40, fontSize: 14 } as const;

  const clientSelect = (sx: object) => (
    <Select
      size="small"
      color="warning"
      displayEmpty
      value={clientFilter ?? ""}
      onChange={(e: any) => setClientFilter(e.target.value)}
      renderValue={(value) => {
        const client = dataClientsFilter.find((elem) => String(elem?.id) === String(value));
        return client ? `Client : ${client?.libelle}` : "Tous les clients";
      }}
      sx={{ ...filterFieldSx, ...sx }}
      MenuProps={{ PaperProps: { sx: { maxHeight: 360 } } }}
    >
      <MenuItem value="" dense>Tous les clients</MenuItem>
      {dataClientsFilter.map((client) => (
        <MenuItem key={client?.id} value={client?.id} dense>
          {client?.libelle}
        </MenuItem>
      ))}
    </Select>
  );

  const statutSelect = (sx: object) => (
    <Select
      size="small"
      color="warning"
      displayEmpty
      value={statutFilter}
      onChange={(e: any) => setStatutFilter(e.target.value)}
      renderValue={(value) => {
        if (value === "1") return "Statut : Activer";
        if (value === "0") return "Statut : Désactiver";
        return "Tous les statuts";
      }}
      sx={{ ...filterFieldSx, ...sx }}
    >
      <MenuItem value="" dense>Tous les statuts</MenuItem>
      <MenuItem value="1" dense>Activer</MenuItem>
      <MenuItem value="0" dense>Désactiver</MenuItem>
    </Select>
  );

  const searchField = (sx: object, showClear: boolean = false, placeholder: string = "Chercher une opération ...") => (
    <TextField
      size="small"
      color="warning"
      placeholder={placeholder}
      value={operationSearch}
      onChange={handleChangeSearchValue}
      onKeyDown={(e) => e.key === "Enter" && handleSearch()}
      sx={{ ...sx, '& .MuiOutlinedInput-root': { ...filterFieldSx } }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              type="button"
              aria-label="search"
              size="small"
              onClick={() => handleSearch()}
            >
              <SearchIcon />
            </IconButton>
            {showClear && (
              <IconButton
                type="button"
                aria-label="refresh"
                size="small"
                onClick={() => resetFilter()}
              >
                <ClearIcon />
              </IconButton>
            )}
          </InputAdornment>
        ),
      }}
    />
  );

  return (
    <>
      <Container maxWidth="lg">
        {isDesktopOrLaptop ? (
          <>
            {/*
              À partir de lg, une seule ligne : les boutons à gauche, un espace vide,
              puis les filtres à droite (client et statut de même largeur, recherche plus large).
              En dessous de lg : deux lignes de trois colonnes de même largeur.
            */}
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: {
                  xs: "repeat(3, minmax(0, 1fr)) auto",
                  lg: "110px 110px 176px minmax(0, 1fr) 160px 160px 208px auto",
                },
                gap: 1,
                alignItems: "center",
              }}
            >
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                color="warning"
                fullWidth
                sx={{ ...toolbarBtnSx }}
                onClick={() => setOpenModal(true)}
              >
                Ajouter
              </Button>
              <LoadingButton
                variant="contained"
                startIcon={<FileDownloadIcon />}
                loading={isExporting}
                loadingPosition="start"
                fullWidth
                onClick={() => handleExport()}
                sx={{ ...toolbarBtnSx, ...whiteBtnSx }}
              >
                Exporter
              </LoadingButton>
              <Button
                variant="contained"
                startIcon={<UpdateIcon />}
                fullWidth
                onClick={() => setOpenCodeGescoModal(true)}
                sx={{ ...toolbarBtnSx, ...whiteBtnSx }}
              >
                Mise à jour code gesco
              </Button>
              {/* La colonne 4 (lg) reste vide : espace entre les boutons et les filtres */}
              {clientSelect({ width: "100%", gridRow: { xs: 2, lg: 1 }, gridColumn: { xs: 1, lg: 5 } })}
              {statutSelect({ width: "100%", gridRow: { xs: 2, lg: 1 }, gridColumn: { xs: 2, lg: 6 } })}
              {searchField({ width: "100%", gridRow: { xs: 2, lg: 1 }, gridColumn: { xs: 3, lg: 7 } }, false, "Rechercher ...")}
              <Tooltip title="Réinitialiser les filtres">
                <IconButton
                  aria-label="refresh"
                  sx={{ color: "#fff", gridColumn: { xs: 4, lg: 8 }, gridRow: { xs: 2, lg: 1 } }}
                  onClick={() => resetFilter()}
                >
                  <RefreshIcon sx={{ fontSize: 30 }} />
                </IconButton>
              </Tooltip>
            </Box>

            <Box mt={4} mb={2} display="flex" justifyContent="left">
              {pagination}
            </Box>

            <TableContainer component={Paper} style={tableStyle}>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell />
                    <StyledTableCell>Client</StyledTableCell>
                    <StyledTableCell>Opération</StyledTableCell>
                    <StyledTableCell>Secteur d’activité</StyledTableCell>
                    <StyledTableCell>Actions</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {totalData > 0 ? (
                    dataOperations.map((operation) => (
                      <OperationRow
                        key={operation?.id}
                        isDesktopOrLaptop={isDesktopOrLaptop}
                        operation={operation}
                        http={http}
                        dataClients={dataClients}
                        dataSocieteFacturations={dataSocieteFacturations}
                        dataSecteurActivites={dataSecteurActivites}
                        setAlertType={setAlertType}
                        setAlerteMessage={setAlerteMessage}
                        setOpenSnack={setOpenSnack}
                        reloadList={reloadList}
                        periodeRefAll={periodeRefAll}
                        expanded={expanded}
                        setExpanded={setExpanded}
                      />
                    ))
                  ) : (
                    <StyledTableCell colSpan={5}>
                      Aucun resultat a été trouvé ...
                    </StyledTableCell>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <Box my={4} display="flex" justifyContent="right">
              {pagination}
            </Box>
          </>
        ) : (
          <>
            <Box sx={{
              position: 'fixed',
              width: '95%',
              top: '10.32rem',
              pr: 1.5,
              pt: 2,
              bgcolor: '#080d24',
              zIndex: 1000
            }}>
              <Stack spacing={0.75}>
                <Button
                  variant="contained"
                  size='small'
                  startIcon={<AddIcon />}
                  color="warning"
                  fullWidth
                  sx={{ ...toolbarBtnSx }}
                  onClick={() => setOpenModal(true)}
                >
                  Ajouter
                </Button>

                <LoadingButton
                  variant="contained"
                  size='small'
                  startIcon={<FileDownloadIcon />}
                  loading={isExporting}
                  loadingPosition="start"
                  fullWidth
                  onClick={() => handleExport()}
                  sx={{ ...toolbarBtnSx, ...whiteBtnSx }}
                >
                  Exporter
                </LoadingButton>

                <Button
                  variant="contained"
                  size='small'
                  startIcon={<UpdateIcon />}
                  fullWidth
                  onClick={() => setOpenCodeGescoModal(true)}
                  sx={{ ...toolbarBtnSx, ...whiteBtnSx }}
                >
                  Mise à jour code gesco
                </Button>
              </Stack>

              <Stack spacing={0.75} mt={1.5}>
                {clientSelect({ width: "100%" })}
                {statutSelect({ width: "100%" })}
                {searchField({ width: "100%" }, true)}
              </Stack>

              <Typography mt={2}>Liste des opérations</Typography>
              <Divider orientation="horizontal" sx={{ bgcolor: "#fff", mb: 3 }} />

              {(!isLoading && totalData > rowsPerPage) && (
                <Box display="flex" justifyContent="end">
                  <Pagination
                    count={Math.ceil(totalData / rowsPerPage)}
                    size="small"
                    color="standard"
                    sx={{ button: { color: "white" }, mb: 2 }}
                    showFirstButton={true}
                    showLastButton={true}
                    siblingCount={0}
                    boundaryCount={1}
                    defaultPage={page}
                    onChange={(event, value) => setPage(value)}
                  />
                </Box>)}
            </Box>

            <Box mt='23.5rem'>
              {dataOperations.map((operation) => (
                <OperationRow
                  key={operation?.id}
                  isDesktopOrLaptop={isDesktopOrLaptop}
                  operation={operation}
                  http={http}
                  dataClients={dataClients}
                  dataSocieteFacturations={dataSocieteFacturations}
                  dataSecteurActivites={dataSecteurActivites}
                  setAlertType={setAlertType}
                  setAlerteMessage={setAlerteMessage}
                  setOpenSnack={setOpenSnack}
                  reloadList={reloadList}
                  periodeRefAll={periodeRefAll}
                  expanded={expanded}
                  setExpanded={setExpanded}
                />
              ))}
            </Box>

            <Stack direction="row" sx={{ mt: 3, mb: 4 }}>
              <InputLabel sx={{ color: "#fff", fontSize: 12, mt: 0.5 }}>Lignes par page :</InputLabel>
              <FormControl variant="standard" sx={{ minWidth: 48 }}>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  color="warning"
                  sx={{
                    background: "#fff",
                    borderRadius: 1,
                    paddingLeft: 1,
                    paddingTop: 0.5,
                    marginLeft: 1,
                    fontSize: 12
                  }}
                  value={rowsPerPage}
                  onChange={(e) => setRowsPerPage(e.target.value as number)}
                  defaultValue={5}
                  size="small"
                >
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={25}>25</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                </Select>
              </FormControl>
            </Stack>
          </>
        )}
      </Container>

      <OptionalWidthModal
        title="Ajouter une nouvelle operation"
        breackPoint="lg"
        onClose={handleClose}
        open={openModal}
      >
        <OperationForm
          http={http}
          defaultClient={defaultClient}
          dataClients={dataClients}
          dataSocieteFacturations={dataSocieteFacturations}
          dataSecteurActivites={dataSecteurActivites}
          setAlertType={setAlertType}
          setAlerteMessage={setAlerteMessage}
          setOpenSnack={setOpenSnack}
          reloadList={reloadList}
          onClose={handleClose}
          periodeRefAll={periodeRefAll}
        />
      </OptionalWidthModal>

      <OptionalWidthModal
        title="Mettre à jour code gesco"
        onClose={handleClose2}
        open={openCodeGescoModal}
      >
        <UpdateCodeGescoForm
          dataSocieteFacturations={dataSocieteFacturations}
          http={http}
          setAlertType={setAlertType}
          setAlerteMessage={setAlerteMessage}
          setOpenSnack={setOpenSnack}
          onClose={handleClose2}
        />
      </OptionalWidthModal>

      {stackAlert}
      <div>
        <Backdrop
          sx={{ color: "white", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    </>
  );
};
export default Operation;
